module.exports = __webpack_public_path__ + "static/media/galeryVinyl10.996766a7.jpg";